module.exports = __webpack_public_path__ + "img/expression-help2.c85c3261.gif";